import axios from '../service/axios/axios'

export default {
  /* *** 结算监测 *** */
  // 获取问诊单模板列表
  orderSettlementMonitor(data) {
    return axios({
      method: 'post',
      url: 'platform/Order/orderSettlementMonitor',
      data: data,
    })
  },
  // 发货监测
  orderDeliverMonitor(data) {
    return axios({
      method: 'post',
      url: 'platform/Order/orderDeliverMonitor',
      data: data,
    })
  },
  // 收货监测
  orderReceivingMonitor(data) {
    return axios({
      method: 'post',
      url: 'platform/Order/orderReceivingMonitor',
      data: data,
    })
  },
  // 测试医生开方监测记录
  testDoctorPrescription(data) {
    return axios({
      method: 'post',
      url: 'platform/Prescription/testDoctorPrescription',
      data: data,
    })
  },
  // 推荐人邀请号未填写监测记录
  doctorInvitationWrite(data) {
    return axios({
      method: 'post',
      url: 'platform/Doctor/doctorInvitationWrite',
      data: data,
    })
  },
  // 获取邀请人信息
  recommenderInfo(data) {
    return axios({
      method: 'post',
      url: 'platform/Doctor/recommenderInfo',
      data: data,
    })
  },
  // 医生绑定邀请人
  doctorBindingRecommender(data) {
    return axios({
      method: 'post',
      url: 'platform/Doctor/doctorBindingRecommender',
      data: data,
    })
  },
}
